export default __webpack_public_path__ + "static/media/hero.398f4fca.jpeg";